export default {
    name: 'kongbai',
    title: '辅助空白',
    height: 16,
    bgColor: '#ffffff',
    transparent: 100
}